import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { PieceTableRenderComponent } from './piece-table-render.component';


export const pieceTableRenderModuleEntryComponents = [
  PieceTableRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule
  ],
  declarations: pieceTableRenderModuleEntryComponents
})
export class PieceTableRenderModule {}

export default pieceTableRenderModuleEntryComponents;
